import { BFormInput } from './form-input';
import { pluginFactory } from '../../utils/plugins';
var FormInputPlugin =
/*#__PURE__*/
pluginFactory({
  components: {
    BFormInput: BFormInput,
    BInput: BFormInput
  }
});
export { FormInputPlugin, BFormInput };


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/form-input/index.js
// module id = 380
// module chunks = 1